<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Campaign</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">What's the Content of the Pin?</div>
              <v-textarea
                rows="3"
                v-model="content"
                hide-details
                dense
                outlined
                placeholder="Pin Content"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1" xs6>
              <div class="subtitle-2 mb-1">Expires In</div>
              <v-select
                dense
                hide-details
                placeholder="Expires In"
                outlined
                v-model="expiryRange"
                :items="expiryRanges"
                @change="onExpiryDateRangeSelected"
                no-data-text="Please select a Schedule Time first"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1" xs6>
              <div class="subtitle-2 mb-1">Frequency</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="['daily', 'weekly', 'monthly']"
                v-model="repeatType"
                @change="createInstances"
                placeholder="Frequency"
              >
              </v-select>
            </v-flex>
            <v-flex class="ml-1" xs6>
              <div class="subtitle-2 mb-1"># of instances</div>
              <v-text-field
                dense
                outlined
                hide-details
                v-model="instanceCount"
                @change="createInstances"
                placeholder="#"
              />
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-2">Schedule</div>
          </v-layout>
          <v-simple-table v-if="instances.length > 0">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Scheduled At</th>
                  <th class="text-left">Expires At</th>
                  <th class="text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(instance, i) in instances">
                  <tr v-if="i < 3" :key="i">
                    <td>
                      {{
                        iMomentFormat(
                          instance.scheduledAt.seconds
                            ? instance.scheduledAt.seconds * 1000
                            : instance.scheduledAt,
                        ).format('MMMM Do, h:mm a')
                      }}
                    </td>
                    <td>
                      {{
                        iMomentFormat(
                          instance.expiresAt.seconds
                            ? instance.expiresAt.seconds * 1000
                            : instance.expiresAt,
                        ).format('MMMM Do, h:mm a')
                      }}
                    </td>
                    <td>
                      <v-chip small label>
                        <span class="text-uppercase font-weight-medium">
                          {{ instance.state }}
                        </span>
                      </v-chip>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </v-simple-table>
          <v-layout class="mt-3" v-if="instances.length > 3">
            <v-btn
              class="text-none"
              color="primary"
              block
              large
              @click="viewFullSchedule"
            >
              <span class="subtitle-2"> View Full Schedule </span>
            </v-btn>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Pin Options</div>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-combobox
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
                @change="entitySelected"
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-layout>
            <!-- {{ entity }} -->
            <v-btn
              v-if="entity.instagram"
              icon
              target="_blank"
              :href="entity.instagram"
            >
              <v-icon>mdi-instagram </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.facebook"
              icon
              target="_blank"
              :href="entity.facebook"
            >
              <v-icon>mdi-facebook </v-icon>
            </v-btn>
            <v-btn
              v-if="entity.website"
              icon
              target="_blank"
              :href="entity.website"
            >
              <v-icon>mdi-globe </v-icon>
            </v-btn>
          </v-layout>
          <v-layout>
            <v-checkbox
              v-model="hasCustomLocation"
              label="Use a custom location"
            ></v-checkbox>
          </v-layout>
          <v-layout v-if="hasCustomLocation">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                outlined
                dense
                v-model="latitude"
                placeholder="Latitude"
              >
              </v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                outlined
                dense
                v-model="longitude"
                placeholder="Longitude"
              >
              </v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <!-- <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="reviewedEntities"
                v-model="entity"
                item-text="title"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout> -->
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Pin Type</div>
              <v-autocomplete
                outlined
                dense
                hide-details
                return-object
                :items="pinTypes"
                v-model="pinType"
                item-text="name"
                placeholder="Pin Type"
                chips
              >
              </v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Link Name</div>
              <v-text-field
                v-model="linkName"
                hide-details
                dense
                outlined
                placeholder="Link Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">Link URL</div>
              <v-text-field
                v-model="linkUrl"
                hide-details
                dense
                outlined
                placeholder="Ex: http://..."
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">is Marker?</div>
              <v-text-field
                v-model="isMarker"
                hide-details
                dense
                outlined
                placeholder="Ex: Bool"
              ></v-text-field>
            </v-flex>
          </v-layout> -->
          <!-- <image-upload-section
            v-if="imageUrl"
            ref="pinImageUploadRef"
            @selectedImage="setPinImage"
          /> -->
          <gallery-image-select-section
            v-if="state === 'scheduled' || state === 'updated'"
            ref="galleryImageSelectSectionRef"
            @imageSelected="galleryImageSelected"
          />

          <v-layout v-if="imageUrl && !selectedFromGallery" class="mt-3">
            <v-flex>
              <v-card>
                <v-img aspect-ratio="1" :lazy-src="imageUrl" :src="imageUrl" />
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
    <full-schedule-dialog :instances="instances" ref="fullScheduleDialog" />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
import FullScheduleDialog from './FullScheduleDialog';
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';

export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    FullScheduleDialog,
    GalleryImageSelectSection,
  },
  data() {
    return {
      dialog: false,
      hasCustomLocation: false,
      latitude: 0,
      longitude: 0,

      repeatType: '',
      instanceCount: 0,
      instances: [],

      searchTerm: '',
      loading: false,
      dialogAction: '',
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      expiryRange: '',
      scheduledAt: '',
      expiresAt: '',
      region: {},
      entity: {},
      createdBy: '',
      content: '',
      bgColor: '',
      iconColor: '',
      iconName: '',
      iconType: '',
      isMarker: true,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      state: '',
      pinType: '',
      id: '',
      linkName: '',
      linkUrl: '',
      score: Number(0),

      totalComments: Number(0),

      views: Number(0),
      selectedFromGallery: false,
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapState('$_entity', ['reviewedEntities']),
    ...mapGetters({
      pinTypes: '$_home/pinTypes',
    }),
    expiryRanges() {
      return this.scheduledAtDateField
        ? ['6 Hours', '12 Hours', '18 Hours', '24 Hours']
        : [];
    },
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.expiresAt;
      }
    },
    changeFieldsCopy() {
      return {
        instances: this.instances,
        repeatType: this.repeatType,
        instanceCount: this.instanceCount,
        state: 'scheduled',
        hasCustomLocation: this.hasCustomLocation,
        pinData: {
          scheduledAt: this.iMoment(this.scheduledAtDateField),
          expiresAt: this.iMoment(this.expiresAtDateString),

          type: 'pin',
          region: this.region,
          expiryRange: this.expiryRange,
          createdBy: {
            id: auth.currentUser.uid,
            email: auth.currentUser.email,
            name: auth.currentUser.displayName,
          },
          entity: this.entity,
          pinType: this.pinType,
          data: {
            title: this.entity.title,
            subTitle: this.entity.subTitle,

            content: this.content,
            createdBy: auth.currentUser.uid,
            graphics: {
              entity: this.pinType.name,
              logoUrl: this.pinType.logo ? this.pinType.logo : '',
              displayPriority: this.pinType.displayPriority,
              icon: {
                bgColor: this.pinType.backgroundColor,
                color: this.pinType.fontColor,
                name: this.pinType.fontName,
                type: this.pinType.fontFamily,
              },
            },
            image: this.imageUrl
              ? {
                  firebaseUrl: this.firebaseUrl,
                  thumbnail: this.imageThumbnail,
                  url: this.imageUrl,
                }
              : null,
            link: this.linkUrl
              ? {
                  url: this.linkUrl,
                  name: this.linkName,
                }
              : null,
            isMarker: this.isMarker,
            location: this.hasCustomLocation
              ? new firebase.firestore.GeoPoint(
                  parseFloat(this.latitude),
                  parseFloat(this.longitude),
                )
              : this.entity.location,
            score: Number(0),

            totalComments: Number(0),
            type: this.pinType.name,
            views: Number(0),
            showInFeed: true,
            entityId: this.entity.id,
            hasProfile: this.entity.hasProfile ? this.entity.hasProfile : false,
            tags: this.entity.tags,
            facebook: this.entity.facebook,
            instagram: this.entity.instagram,
            website: this.entity.website,
            phone: this.entity.phone,
            address: this.entity.address,
          },
        },
      };
    },

    changeFields() {
      return {
        id: this.id,

        instances: this.instances,
        repeatType: this.repeatType,
        instanceCount: this.instanceCount,
        state: 'scheduled',

        hasCustomLocation: this.hasCustomLocation,
        pinData: {
          scheduledAt: this.iMoment(this.scheduledAtDateField),
          expiresAt: this.iMoment(this.expiresAtDateString),

          type: 'pin',
          region: this.region,
          expiryRange: this.expiryRange,
          entity: this.entity,
          pinType: this.pinType,
          data: {
            title: this.entity.title,
            subTitle: this.entity.subTitle,

            content: this.content,
            createdBy: auth.currentUser.uid,
            graphics: {
              entity: this.pinType.name,
              logoUrl: this.pinType.logo ? this.pinType.logo : '',
              displayPriority: this.pinType.displayPriority
                ? this.pinType.displayPriority
                : Number(0),
              icon: {
                bgColor: this.pinType.backgroundColor,
                color: this.pinType.fontColor,
                name: this.pinType.fontName,
                type: this.pinType.fontFamily,
              },
            },
            image: this.imageUrl
              ? {
                  firebaseUrl: this.firebaseUrl,
                  thumbnail: this.imageThumbnail,
                  url: this.imageUrl,
                }
              : null,
            link: this.linkUrl
              ? {
                  url: this.linkUrl,
                  name: this.linkName,
                }
              : null,
            isMarker: this.isMarker,
            location: this.hasCustomLocation
              ? new firebase.firestore.GeoPoint(
                  parseFloat(this.latitude),
                  parseFloat(this.longitude),
                )
              : this.entity.location,
            score: this.score,

            totalComments: this.totalComments,
            type: this.pinType.name,
            views: this.views,
            showInFeed: true,
            entityId: this.entity.id,
            hasProfile: this.entity.hasProfile ? this.entity.hasProfile : false,
            tags: this.entity.tags,
            facebook: this.entity.facebook,
            instagram: this.entity.instagram,
            website: this.entity.website,
            phone: this.entity.phone,
            address: this.entity.address,
          },
        },
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function(e) {
      e && this.searchEntities(e);
    }, 300),
  },
  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    // this.getEntityTypes({
    //   collection: "entityTypes",
    //   mutation: "updateEntityTypes",
    // });
  },
  methods: {
    ...mapActions({
      createNewCampaign: '$_content/createNewContent',
      updateCampaign: '$_content/updateContent',
      uploadImage: '$_content/uploadImage',
      getRegions: '$_home/getContent',
      getEntityTypes: '$_home/getContent',
      getPins: '$_content/getContent',
      getCampaignsByRegion: '$_content/getContentByRegion',
      searchEntitiesAction: '$_entity/searchContent',
    }),
    entitySelected(entity) {
      if (entity) {
        // this.pinType = entity.default ? entity.default.pinType : {};
        this.linkUrl = entity.default ? entity.default.linkUrl : '';
        this.linkName = entity.default ? entity.default.linkName : '';
        this.latitude = entity.location.latitude;
        this.longitude = entity.location.longitude;
        this.region = entity.region;
      } else {
        this.latitude = 0;
        this.longitude = 0;
      }
    },
    viewFullSchedule() {
      this.$refs.fullScheduleDialog.toggleDialog();
    },
    searchEntities(searchTerm) {
      this.loading = true;
      console.log('searching Tags: ', searchTerm);

      this.searchEntitiesAction({
        collection: 'entities',
        mutation: 'updateReviewedEntities',
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    iMomentFormat(date) {
      if (date) {
        // console.log(date);
        return moment(date);
      }
      return new Date();
    },
    toggleDialog(details, action) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log('Edit Details: ', details);
        this.dialogAction = action;

        this.id = details.id;

        if (action != 'copy') {
          this.scheduledAtDateField = details.pinData.scheduledAt
            ? details.pinData.scheduledAt.seconds * 1000
            : '';
          this.expiresAtDateField = details.pinData.expiresAt
            ? details.pinData.expiresAt.seconds * 1000
            : '';
          this.scheduledAt = this.iMoment(
            details.pinData.scheduledAt.seconds * 1000,
          );
          this.expiresAt = this.iMoment(
            details.pinData.expiresAt.seconds * 1000,
          );
          this.expiryRange = details.pinData.expiryRange;
          this.repeatType = details.repeatType;
          this.instanceCount = details.instanceCount;
          this.instances = details.instances;
        } else {
          this.instanceCount = 0;
          this.instances = [];
        }

        this.state = details.state;
        this.region = details.pinData.region;
        this.entity = details.pinData.entity;
        this.pinType = details.pinData.pinType;
        this.createdBy = details.createdBy;
        this.content = details.pinData.data.content;
        this.bgColor = details.pinData.data.graphics.icon.bgColor;
        this.iconColor = details.pinData.data.graphics.icon.color;
        this.iconName = details.pinData.data.graphics.icon.name;
        this.iconType = details.pinData.data.graphics.icon.type;
        this.hasCustomLocation = details.hasCustomLocation
          ? details.hasCustomLocation
          : false;
        //   this.isMarker = true;
        if (details.hasCustomLocation) {
          this.latitude = details.pinData.data.location.latitude;
          this.longitude = details.pinData.data.location.longitude;
        } else {
          this.location = details.pinData.data.location;
          this.latitude = details.pinData.data.location.latitude;
          this.longitude = details.pinData.data.location.longitude;
        }
        this.imageThumbnail = details.pinData.data.image
          ? details.pinData.data.image.thumbnail
          : '';
        this.firebaseUrl = details.pinData.data.image
          ? details.pinData.data.image.firebaseUrl
            ? details.pinData.data.image.firebaseUrl
            : ''
          : '';
        this.imageUrl = details.pinData.data.image
          ? details.pinData.data.image.url
          : '';
        this.score = details.pinData.data.score;
        this.totalComments = details.pinData.data.totalComments;
        this.views = details.pinData.data.views;
        this.linkUrl = details.pinData.data.link
          ? details.pinData.data.link.url
          : '';
        this.linkName = details.pinData.data.link
          ? details.pinData.data.link.name
          : '';
      }
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expiresAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
      if (this.expiresAtDateField && this.repeatType) {
        this.onExpiryDateRangeSelected(this.expiryRange);
        this.createInstances();
      }
    },
    onExpiryDateRangeSelected(timeRange) {
      console.log('Expiry Selected time range: ', timeRange);
      switch (timeRange) {
        case '6 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            6,
            'hours',
          );
          break;
        case '12 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            12,
            'hours',
          );
          break;
        case '18 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            18,
            'hours',
          );
          break;
        case '24 Hours':
          this.expiresAtDateField = moment(this.scheduledAtDateField).add(
            24,
            'hours',
          );
          break;
        default:
          this.expiresAtDateField = this.scheduledAtDateField;
      }
      this.createInstances();
    },
    createInstances() {
      this.instances = [];
      console.log(this.expiresAtDateField);
      for (var i = 0; i < this.instanceCount; i++) {
        switch (this.repeatType) {
          case 'daily':
            this.instances.push({
              scheduledAt: moment(this.scheduledAtDateField)
                .add(i, 'days')
                .toDate(),
              expiresAt: moment(this.expiresAtDateField)
                .add(i, 'days')
                .toDate(),
              state: 'created',
            });

            break;
          case 'weekly':
            console.log(
              moment(this.expiresAtDateField)
                .add(i, 'weeks')
                .toDate(),
            );
            this.instances.push({
              scheduledAt: moment(this.scheduledAtDateField)
                .add(i, 'weeks')
                .toDate(),
              expiresAt: moment(this.expiresAtDateField)
                .add(i, 'weeks')
                .toDate(),
              state: 'created',
            });
            break;
          case 'monthly':
            this.instances.push({
              scheduledAt: moment(this.scheduledAtDateField)
                .add(i, 'months')
                .toDate(),
              expiresAt: moment(this.expiresAtDateField)
                .add(i, 'months')
                .toDate(),
              state: 'created',
            });
            break;
        }
      }
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.imageUrl = image.url;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';
      this.insances = [];
      this.repeatType = '';
      this.instanceCount = 0;
      this.region = '';
      this.state = '';
      this.region = {};
      this.entity = {};
      this.createdBy = '';
      this.content = '';
      this.bgColor = '';
      this.iconColor = '';
      this.iconName = '';
      this.iconType = '';
      this.isMarker = true;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';
      this.pinType = {};
      this.expiryRange = '';
      this.latitude = 0;
      this.longitude = 0;
      this.id = '';
      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }
      this.selectedFromGallery = false;

      // if (this.imageUrl) {
      //   this.$refs.pinImageUploadRef.removeImage(0);
      // }

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      if (!this.scheduledAtDateString) {
        alert('Yo yo, Slow down dude, add a Scheduled At time');
        return;
      }
      if (this.dialogAction === 'copy') {
        this.createNewCampaign({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Campaign',
        }).then(() => {
          this.cancel();
          this.getCampaignsByRegion({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
          });
        });
      } else {
        this.updateCampaign({
          details: this.changeFields,
          collection: this.collection,
          type: 'Campaign',
        }).then(() => {
          this.cancel();
          this.getCampaignsByRegion({
            type: 'campaign',
            collection: this.collection,
            mutation: 'updateCampaigns',
            region: this.selectedRegion,
          });
        });
      }
    },
  },
};
</script>

<style></style>
